// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__XVKjk","section":"index_section__5kvVO"};